import { Component } from "@angular/core";
import { OAuthService } from "angular-oauth2-oidc";
import { LOGIN_STATUS } from "src/app/config/constants";

@Component({
    standalone: false,
    selector: "cbms-error",
    templateUrl: "./error.component.html",
    styleUrls: ["./error.component.scss"],
})
export class ErrorComponent {
    currentYear = new Date().getFullYear();
    buttonLabel = "";

    constructor() {
        this.buttonLabel =
            localStorage.getItem(LOGIN_STATUS) === "true"
                ? "Go to Homepage"
                : "Return to Login";
    }

    logout() {
        location.href = "/";
    }
}
